@if (isLoading()) {
  <div class="ion-text-center ion-padding ion-margin-top">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Cargando detalles del documento...</p>
  </div>
} @else {
  @if (document(); as item) {
    <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

    <ion-list class="block-content-round no-padding">
      @if (!item.carrier.contactEmail || hasMissingNetWeight() || hasMissingPlates()) {
        <ion-item-group class="bg-danger">
          <ion-item-divider sticky>
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/warning_24dp.svg"
              class="txt-danger"
            ></ion-icon>
            <div>
              <p class="subtitle txt-danger">Documento incompleto / no válido</p>
            </div>
          </ion-item-divider>
          <div class="detail-group">
            <div class="fs-sm ion-padding">
              <p class="">Faltan los siguientes datos para que el documento sea válido como documento de control:</p>
              <ul class="fs-sm">
                @if (!item.carrier.contactEmail) {
                  <li><strong>Transportista efectivo</strong> con acceso al documento (requiere tener un email)</li>
                }
                @if (hasMissingNetWeight()) {
                  <li><strong>Peso</strong> neto de la mercancía en al menos un tramo</li>
                }
                @if (hasMissingPlates()) {
                  <li><strong>Matrícula</strong> de los vehículos utilizados en al menos un tramo</li>
                }
              </ul>
            </div>
          </div>
        </ion-item-group>
      }

      @if (isPastDocument()) {
        <ion-item-group class="bg-info">
          <ion-item-divider sticky>
            <ion-icon
              slot="start"
              aria-hidden="true"
              [src]="
                isShipper()
                  ? '../assets/material-symbols/snippet_folder_24dp.svg'
                  : '../assets/material-symbols/okc_folder_qr_code_24dp.svg'
              "
            ></ion-icon>
            <div>
              <p class="subtitle">Documento archivado</p>
            </div>
          </ion-item-divider>
          <div class="detail-group">
            <p class="ion-text-center fs-sm ion-padding-bottom">
              <strong>
                Este documento es de un transporte anterior a la fecha actual. El único cambio posible es añadir
                anotaciones.
              </strong>
            </p>
          </div>
        </ion-item-group>
      }

      @if (isEditBlockedByShipper()) {
        <ion-item-group class="bg-info">
          <ion-item-divider sticky>
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/info_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">Documento no modificable</p>
            </div>
          </ion-item-divider>
          <div class="detail-group">
            <p class="ion-text-center fs-sm ion-padding-bottom">
              <strong>
                Los documentos cuyo cargador contractual es {{ item.shipper.companyName }} no pueden ser modificados
                desde esta sección
              </strong>
            </p>
            <p class="ion-text-center fs-sm ion-padding-bottom">
              {{ 'deca.detail.changes_blocked_hint' | translate }}
              <strong>
                <a
                  [href]="changesBlockedFreightsUrl"
                  target="_blank"
                  rel="noopener"
                  >{{ 'deca.detail.assigned_freights_link' | translate }}</a
                >
              </strong>
            </p>
          </div>
        </ion-item-group>
      }

      <ion-item-group>
        <ion-item-divider sticky>
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/description_24dp.svg"
          ></ion-icon>
          <div>
            <p class="subtitle">Datos generales del documento</p>
          </div>
        </ion-item-divider>

        <div class="detail-group">
          <ion-grid class="ion-no-padding">
            <ion-row>
              <ion-col
                size="12"
                size-lg="6"
                class="ion-text-center"
              >
                <div class="ion-margin-bottom">
                  <img
                    [src]="item.qrUrl"
                    alt="Código QR del documento de control"
                    style="max-width: 200px; width: 100%"
                  />
                </div>
                @if (item.pdfUrl) {
                  <p>
                    <ion-button
                      [href]="item.pdfUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ion-icon
                        aria-hidden="true"
                        slot="start"
                        src="../assets/material-symbols/print_24dp.svg"
                      ></ion-icon>
                      Documento PDF
                    </ion-button>
                    <ion-button
                      fill="outline"
                      class="ion-margin-start"
                      aria-label="Copiar el enlace del documento PDF"
                      (click)="copyPdfUrl()"
                    >
                      <ion-icon
                        aria-hidden="true"
                        slot="start"
                        src="../assets/material-symbols/content_copy_24dp.svg"
                      ></ion-icon>
                      Copiar enlace PDF
                    </ion-button>
                  </p>
                }
              </ion-col>
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="detail-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/barcode_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">Referencia interna</p>
                    <p>
                      <strong>{{ item.reference }}</strong>
                    </p>
                  </div>
                </div>
                <div class="detail-data-block">
                  <ion-icon aria-hidden="true"></ion-icon>
                  <div>
                    <p class="subtitle">Identificador</p>
                    <p class="fs-sm">{{ item.id }}</p>
                  </div>
                </div>
                <div class="detail-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/calendar_clock_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">Fecha de creación</p>
                    <p class="fs-sm">{{ item.createdAt | dfnsFormat: 'ccc Pp' }}&nbsp;h</p>
                  </div>
                </div>
                <div class="detail-data-block">
                  <ion-icon aria-hidden="true"></ion-icon>
                  <div>
                    <p class="subtitle">Creado por:</p>
                    @if (item.carrier.id === item.createdByCompanyId) {
                      <p class="fs-sm">{{ item.carrier.companyName }} <span class="fs-xs">(TRANSPORTISTA)</span></p>
                    }
                    @if (item.shipper.id === item.createdByCompanyId) {
                      <p class="fs-sm">{{ item.shipper.companyName }} <span class="fs-xs">(CARGADOR)</span></p>
                    }
                    @if (item.createdByCompanyId === userCompanyId() && !isPastDocument()) {
                      <div class="fs-xs">
                        <span class="bg-info help-box">
                          <ion-icon
                            aria-hidden="true"
                            src="../assets/material-symbols/info_24dp.svg"
                          ></ion-icon>
                          <strong>Puedes editar cualquier dato del documento</strong>
                        </span>
                      </div>
                    }
                  </div>
                </div>
                <div class="detail-data-block">
                  <ion-icon aria-hidden="true"></ion-icon>
                  <div>
                    <p class="subtitle">Fecha de última modificación</p>
                    <p class="fs-sm">{{ item.updatedAt | dfnsFormat: 'ccc Pp' }}&nbsp;h</p>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-item-group>

      <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
          <ion-col
            size="12"
            size-lg="6"
            class="ion-no-padding"
          >
            <ion-item-group>
              <ion-item-divider sticky>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/box_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">Cargador contractual</p>
                </div>
              </ion-item-divider>
              <div class="detail-group">
                <ion-grid class="ion-no-padding">
                  <ion-row>
                    <ion-col size="12">
                      <div class="detail-data-block">
                        <ion-icon aria-hidden="true"></ion-icon>
                        <div>
                          <p>
                            <strong>{{ item.shipper.companyName }}</strong>
                            - NIF: {{ item.shipper.taxId }}
                          </p>
                          <p class="fs-sm">
                            {{ item.shipper.street }}, {{ item.shipper.city }}, ({{ item.shipper.postalCode }})
                            {{ 'states.' + item.shipper.countryCode + item.shipper.stateCode | translate }},
                            {{ 'countries.' + item.shipper.countryCode | translate }}
                          </p>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-item-group>
          </ion-col>

          <ion-col
            size="12"
            size-lg="6"
            class="ion-no-padding"
          >
            <ion-item-group>
              <ion-item-divider sticky>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">Transportista efectivo</p>
                </div>
              </ion-item-divider>
              <div class="detail-group">
                <ion-grid class="ion-no-padding">
                  <ion-row>
                    <ion-col size="12">
                      <div class="detail-data-block">
                        <ion-icon aria-hidden="true"></ion-icon>
                        <div>
                          @if (item.carrier.taxId && item.carrier.companyName) {
                            <p>
                              <strong>{{ item.carrier.companyName }}</strong>
                              - NIF: {{ item.carrier.taxId }}
                            </p>
                            <p class="fs-sm">
                              {{ item.carrier.street }}, {{ item.carrier.city }}, ({{ item.carrier.postalCode }})
                              {{ 'states.' + item.carrier.countryCode + item.carrier.stateCode | translate }},
                              {{ 'countries.' + item.carrier.countryCode | translate }}
                            </p>
                          } @else {
                            <p>
                              <strong>
                                <ion-text color="danger">No se ha indicado transportista efectivo</ion-text>
                              </strong>
                            </p>
                          }
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-item-group>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item-group>
              <ion-item-divider sticky>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_filled_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">Medios de transporte</p>
                </div>
              </ion-item-divider>
              <div class="detail-group">
                <ion-grid class="ion-no-padding">
                  <ion-row>
                    <ion-col
                      size="12"
                      size-lg="6"
                    >
                      <div class="detail-data-block">
                        <ion-icon aria-hidden="true"></ion-icon>
                        <div>
                          <p>
                            <strong>Matrículas: </strong>
                            @if (item.tractorPlateNumber) {
                              <span class="plate-number">{{ item.tractorPlateNumber }}</span>
                              @if (item.trailerPlateNumber) {
                                - <span class="plate-number">{{ item.trailerPlateNumber }}</span>
                              }
                            } @else {
                              <strong><ion-text color="danger">Sin asignar</ion-text></strong>
                            }
                          </p>
                          @if (canModifyVehicles() && isCarrier() && !isCreator() && !isPastDocument()) {
                            <ion-button
                              shape="round"
                              fill="outline"
                              size="small"
                              (click)="openEditPlatesModal()"
                              [disabled]="actionsDisabled()"
                            >
                              <ion-icon
                                slot="start"
                                src="../assets/material-symbols/edit_24dp.svg"
                              ></ion-icon>
                              Editar matrículas
                            </ion-button>
                          }
                        </div>
                      </div>
                    </ion-col>
                    <ion-col
                      size="12"
                      size-lg="6"
                    >
                      <div class="detail-data-block">
                        <ion-icon aria-hidden="true"></ion-icon>
                        <div>
                          <p class="fs-sm">
                            @if (item.specialAuthorizationType) {
                              <strong>Autorización especial:</strong> {{ item.specialAuthorizationType }}
                            } @else {
                              No requiere autorización especial
                            }
                          </p>
                          @if (canModifyVehicles() && isCarrier() && !isCreator() && !isPastDocument()) {
                            <ion-button
                              shape="round"
                              fill="outline"
                              size="small"
                              (click)="openEditAuthorizationModal()"
                              [disabled]="actionsDisabled()"
                            >
                              <ion-icon
                                slot="start"
                                src="../assets/material-symbols/edit_24dp.svg"
                              ></ion-icon>
                              Editar autorización
                            </ion-button>
                          }
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-item-group>
          </ion-col>
        </ion-row>
      </ion-grid>

      @for (segment of item.segments; track segment.id; let i = $index) {
        <lib-deca-detail-segment
          [segment]="segment"
          [index]="i"
          [totalSegments]="item.segments.length"
          [canModifyGoodsData]="canModifyGoodsData()"
          [canModifyLocations]="canModifyLocations()"
          [canModifyDates]="canModifyDates()"
          [isShipper]="isShipper()"
          [isCarrier]="isCarrier()"
          [isCreator]="isCreator()"
          [isPastDocument]="isPastDocument()"
          [actionsDisabled]="actionsDisabled()"
          (editGoods)="openEditGoodsDescriptionModal(segment)"
          (editWeight)="openEditNetWeightModal(segment)"
          (editDate)="openEditDateModal(segment, $event)"
          (editAddress)="openEditAddressModal(segment, $event)"
        ></lib-deca-detail-segment>
      }

      <!-- Reservas / anotaciones -->
      <ion-item-group>
        <ion-item-divider sticky>
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/notes_24dp.svg"
          ></ion-icon>
          <div>
            <p class="subtitle">Reservas / anotaciones</p>
          </div>
        </ion-item-divider>
        <div class="detail-group">
          <ion-grid class="ion-no-padding">
            <ion-row>
              <ion-col size="12">
                <div class="detail-data-block">
                  <ion-icon aria-hidden="true"></ion-icon>
                  <div>
                    @for (reservation of item.reservations; track $index) {
                      <p>{{ reservation }}</p>
                    } @empty {
                      <p class="fs-sm">No hay reservas o anotaciones registradas para este documento.</p>
                    }

                    @if (canModifyReservations()) {
                      <ion-button
                        shape="round"
                        fill="outline"
                        size="small"
                        (click)="openAddReservationModal()"
                        [disabled]="actionsDisabled()"
                      >
                        <ion-icon
                          slot="start"
                          src="../assets/material-symbols/edit_24dp.svg"
                        ></ion-icon>
                        Añadir anotación
                      </ion-button>
                    }
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-item-group>
    </ion-list>
  }
}
